import { IconPack } from "Explore/Config/Icons";
import { Breadcrumb } from "antd";
import styles from "./InstitutionHeader.module.scss";

const InstitutionHeader = ({
  tab,
  setTab,
  landscape,
  institution_name,
  setSelectedUnit,
  setSelectedUnitId,
  selectedUnitQueue,
  setSelectedUnitQueue,
}) => {
  const handleNavigateBreadCrumb = (index) => {
    if (index == -1) {
      setSelectedUnit(null);
      setSelectedUnitId(null);
      setSelectedUnitQueue([]);
    } else {
      setSelectedUnit(selectedUnitQueue[index].name);
      setSelectedUnitId(selectedUnitQueue[index].id);
      setSelectedUnitQueue(selectedUnitQueue.slice(0, index + 1));
    }
  };
  const headerItems = [
    {
      title: (
        <div
          className={styles["bread-crumb"]}
          onClick={() => handleNavigateBreadCrumb(-1)}
        >
          {IconPack.institution_outline_white}
          <span>{institution_name}</span>
        </div>
      ),
    },
    ...selectedUnitQueue?.map((item, index) => {
      return {
        title: (
          <div
            onClick={() => handleNavigateBreadCrumb(index)}
            className={
              index == selectedUnitQueue.length - 1
                ? styles["bread-crumb-current"]
                : styles["bread-crumb"]
            }
          >
            <span>{item.name}</span>
          </div>
        ),
      };
    }),
  ];
  const tab_items = [
    {
      label: `General Information`,
      key: 1,
    },
    {
      label: `Academic Units`,
      key: 2,
    },
  ];

  return (
    <div className={styles["institution-header"]}>
      {landscape ? (
        <div className={styles["breadcrumb"]}>
          <Breadcrumb items={headerItems} />
        </div>
      ) : (
        <div className={styles["breadcrumb-no-landscape"]}>
          <Breadcrumb items={headerItems} />
        </div>
      )}
      <div className={styles["tabs"]}>
        {tab_items.map((item, index) => {
          return (
            <div
              key={index}
              className={
                item.key == tab
                  ? `${styles[landscape ? "tab" : "tab-no-landscape"]} ${
                      styles[landscape ? "selected" : "selected-no-landscape"]
                    }`
                  : styles[landscape ? "tab" : "tab-no-landscape"]
              }
              onClick={(e) => {
                e.preventDefault();
                setTab(item.key);
              }}
            >
              <p>{item.label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InstitutionHeader;
